export default __webpack_public_path__ + "e35326c3780d176c18b602f2679fb4c5.svg";